import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

const GoogleIcon = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true">
    <path fill="#EA4335" d="M12 10.2v3.9h5.5c-.2 1.3-1.6 3.8-5.5 3.8-3.3 0-6-2.7-6-6.1s2.7-6.1 6-6.1c1.9 0 3.1.8 3.8 1.5l2.6-2.5C16.8 3.2 14.6 2.2 12 2.2 6.6 2.2 2.2 6.6 2.2 12s4.4 9.8 9.8 9.8c5.7 0 9.4-4 9.4-9.6 0-.6-.1-1.1-.2-1.6H12z" />
  </svg>
);

const AppleIcon = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4 fill-current" aria-hidden="true">
    <path d="M16.37 12.6c-.02-2.3 1.88-3.4 1.97-3.46-1.07-1.57-2.74-1.78-3.33-1.8-1.42-.14-2.77.83-3.49.83-.72 0-1.83-.81-3.01-.79-1.55.02-2.98.9-3.78 2.29-1.61 2.8-.41 6.94 1.16 9.21.77 1.11 1.68 2.36 2.88 2.31 1.16-.05 1.59-.75 2.99-.75 1.4 0 1.79.75 3.01.72 1.24-.02 2.03-1.13 2.79-2.25.88-1.29 1.24-2.53 1.26-2.6-.03-.01-2.42-.93-2.45-3.71zM14.08 5.85c.64-.77 1.07-1.85.95-2.92-.92.04-2.03.61-2.69 1.38-.59.68-1.11 1.77-.97 2.82 1.03.08 2.07-.52 2.71-1.28z" />
  </svg>
);

export const safeNext = (path) => (path && path.startsWith("/") && !path.startsWith("//") ? path : "/sessions");

export function SocialSignIn({ mode = "in", next = "/sessions" }) {
  const [appleEnabled, setAppleEnabled] = useState(false);
  const verb = mode === "up" ? "Sign up" : "Continue";

  useEffect(() => {
    api.get("/auth/providers").then(({ data }) => setAppleEnabled(!!data.apple)).catch(() => {});
  }, []);

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + next;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const apple = async () => {
    const { data } = await api.post("/auth/apple/start", { origin: window.location.origin, next });
    window.location.href = data.url;
  };

  const base = "w-full gap-2 h-10 font-medium";
  return (
    <div className="space-y-3" data-testid="social-signin">
      <Button type="button" variant="outline" onClick={google} className={base} data-testid="google-signin-button">
        <GoogleIcon /> {verb} with Google
      </Button>
      {appleEnabled && (
        <Button type="button" onClick={apple} className={`${base} bg-black hover:bg-neutral-800 text-white`} data-testid="apple-signin-button">
          <AppleIcon /> {verb} with Apple
        </Button>
      )}
      <div className="flex items-center gap-3 text-xs uppercase tracking-widest text-muted-foreground">
        <span className="h-px flex-1 bg-[var(--brand-border)]" /> or with email <span className="h-px flex-1 bg-[var(--brand-border)]" />
      </div>
    </div>
  );
}
